export default () => {
  // console.log("i am coming the inside function");
  let now = new Date();
  let month = now.getMonth() + 1;
  let day = now.getDate();
  let today =
    now.getFullYear() +
    "-" +
    (month < 10 ? "0" + month : month) +
    "-" +
    (day < 10 ? "0" + day : day);

  // console.log('dateformater', today);
  //TODO: before was return today, but for the pdf print reason, change to ""
  return "";
};



// WEBPACK FOOTER //
// ./src/app/tooltip/dateformater.ts